<template>
  <div>
    <div v-if="!isEmpty(list)">
      <van-cell-group>
        <van-cell title="产品名称" :value="list.name"/>
        <!-- <van-cell title="产品类型" :value="productType1"/> -->
        <van-cell title="客群类型" :value="custType"/>
        <van-cell title="所属银行" :value="bank"/>
        <van-cell title="银行名称" :value="list.bankName"/>
        <van-cell title="面向对象" :value="list.target"/>
        <van-cell title="产品简介" :value="list.briefInfo"/>
        <van-cell title="产品利率" :value="list.rate | formatPercent3"/>
        <van-cell title="产品期限" :value="list.proLimit"/>
        <van-cell title="产品额度(万元)" :value="list.quota"/>
        <van-cell title="利率浮动比率" :value="list.limitScales | formatPercent3"/>
        <!-- <van-cell title="产品额度浮动比率" :value="list.quotaCales | formatPercent3" /> -->
        <van-cell title="抵质押要求" :value="list.pledgeType"/>
        <van-cell title="产品特色" :value="list.productFeature"/>
        <van-cell title="产品说明书" :value="list.manualUrl"/>
        <van-cell title="在线办理标识" :value="applyType"/>
        <van-cell title="在线办理网址" :value="list.applyUrl"/>
        <van-cell title="客户经理姓名" :value="list.amName"/>
        <van-cell title="客户经理电话" :value="list.amPhone"/>
        <van-cell title="客户经理邮箱" :value="list.amEmail"/>
        <van-cell title="拒绝原因" v-if="list.remark" :value="list.remark"/>
      </van-cell-group>
      <div class="btns">
        <van-button type="info" class="cancle-btn" @click="$router.go(-1)">返回</van-button>
        <van-button
          type="info"
          class="cancle-btn"
          v-if="hasBtn"
          @click="cancleBtnHandle"
        >{{ btnText }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { productDetailInfoHandle, getCorpId, BankTypeName } from "@/api/user";
import {
  productTypeList,
  bankNameList,
  applyTypeList,
  custTypeList
} from "./transEnToCn";

export default {
  data() {
    return {
      btnText: ""
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.user.userInfo;
    },
    list() {
      return this.$store.state.product.productListDetails;
    },
    sessionId() {
      return this.$store.state.user.sessionId;
    },
    productType() {
      // 已申请、已发布...
      return this.$store.state.product.productType;
    },
    productListDetails() {
      return this.$store.state.product.productListDetails;
    },
    hasBtn() {
      if (this.productType == "审批中") {
        this.btnText = "撤销";
        return true;
      }
      if (this.productType == "已发布") {
        this.btnText = "关闭";
        return true;
      }
      if (this.productType == "已拒绝") {
        this.btnText = "修改";
        return true;
      } else {
        return false;
      }
    },
    // productType1() {
    //   //后台返回的list里的productType
    //   return this.getCnNameByValue(productTypeList);
    // },
    custType() {
      return this.getCnNameByValue(custTypeList);
    },
    applyType() {
      return this.getCnNameByValue(applyTypeList);
    },
    bank() {
      return this.getCnNameByValue(bankNameList);
    }
  },
  methods: {
    cancleBtnHandle() {
      if (this.btnText != "修改") {
        this.$dialog
          .confirm({
            title: "提示",
            message: `确认${this.btnText}该产品么？`
          })
          .then(() => {
            // on confirm
            this._productDetailInfoHandle();
          })
          .catch(() => {
            // on cancel
          });
      } else {
        // 修改流程
        this.$router.push({
          name: "productUpdate",
          params: {
            list: this.list
          }
        });
      }
    },
    async _productDetailInfoHandle() {
      let apiCode;
      let tempObj = {
        sessionId: this.sessionId
      };
      if (this.btnText == "撤销") {
        apiCode = "SSHJRBPI003";
        tempObj = {
          ...tempObj,
          proInstanceId: this.list.proInstanceId
        };
      }
      if (this.btnText == "关闭") {
        apiCode = "SSHJRBPI004";
        tempObj = {
          ...tempObj,
          productId: this.list.productId
        };
      }

      productDetailInfoHandle(apiCode, {
        data: {
          ...tempObj
        }
      })
        .then(res => {
          if (this.btnText == "关闭") {
            this.$toast("等待审核中");
          } else {
            this.$toast(res.resInfo);
          }

          if (res.resCode == "0000") {
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    isEmpty(obj) {
      if (Object.keys(obj).length === 0) {
        return true;
      }
      return false;
    },
    findAssciate() {
      return new Promise((resolve, reject) => {
        if (this.sessionId) {
          let userType = JSON.parse(this.userInfo).type;
          if (userType === "ent") {
            resolve(JSON.parse(this.userInfo).userId);
          } else {
            //个人登录查找关联法人的机构号
            getCorpId(this.sessionId).then(res => {
              if (res.respCode == "00000000") {
                if (res.respData != null && res.respData.length > 0) {
                  resolve(res.respData[0].legalPerDetail.userId);
                }
              }
            });
          }
        }
      });
    },
    getCnNameByValue(arr = []) {
      // 根据英文查中文
      let val = "";
      if (arr && arr.length > 0) {
        arr.forEach(item => {
          for (const key in this.list) {
            if (item.value == this.list[key]) {
              val = item.text;
            }
          }
        });
      }
      // console.log("转译后", val);
      return val;
    }
  }
};
</script>

<style lang="less" scoped>
.cancle-btn {
  width: 84%;
  margin: 16px auto 30px;
}
.btns {
  margin: 10px 0 20px;
  display: flex;
  justify-content: space-around;
  button {
    width: 40%;
  }
}
</style>